export default __webpack_public_path__ + "static/media/filmfare fiesta.1cd15981.jpg";